import { render, staticRenderFns } from "./CmsProductRootTreeNode.vue?vue&type=template&id=a5312a62&scoped=true&"
import script from "./CmsProductRootTreeNode.vue?vue&type=script&lang=js&"
export * from "./CmsProductRootTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./CmsProductRootTreeNode.vue?vue&type=style&index=0&id=a5312a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5312a62",
  null
  
)

export default component.exports